<template>
  <div class="trezo-card mb-[25px]">
    <div class="trezo-card-content lg:flex justify-between items-center">
      <div>
        <h5 class="mb-[6px] md:mb-[3px] font-semibold text-[20px]">
          Welcome Back, <span class="text-primary-500">Olivia!</span>
        </h5>
        <p>
          Monitor and manage employee performance, attendance and more in one
          place.
        </p>
      </div>
      <div class="flex items-center gap-[10px] mt-[12px] lg:mt-0">
        <button
          type="button"
          class="inline-block flex gap-[4px] items-center text-purple-700 bg-purple-100 rounded-[4px] py-[4.5px] px-[10px] md:px-[12.5px] transition-all hover:bg-purple-200"
        >
          <img src="@/assets/images/icons/crown.svg" alt="crown" />
          Plan Upgrade
        </button>
        <button
          type="button"
          class="inline-block flex gap-[4px] items-center text-orange-700 bg-orange-100 rounded-[4px] py-[4.5px] px-[10px] md:px-[12.5px] transition-all hover:bg-orange-200"
        >
          <img
            src="@/assets/images/icons/file-download.svg"
            alt="file-download"
          />
          Export Reports
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "WelcomeBack",
});
</script>
